var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({class:_vm.iconClass},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.mdi))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.tooltipText))])]),_c('span',{style:(_vm.infoStyle)},[_vm._v(_vm._s(_vm.infoText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }